import httpUtils from '../../utils/HttpUtils'

class SupervisorAreaService {

  async list (supervisorId) {
    var result = null;
    try {
      result = await httpUtils.post('/server/supervisor/area/list',{supervisorId});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new SupervisorAreaService()
